import Styles from './ProcessingContent.module.scss'
import { Spinner } from 'common/Spinner/Spinner'
import { Text } from 'blaze-ui/Text/Text'
import { ProcessingContentProps } from './Types'
import { DesignProcessingMessage } from './DesignPreview/DesignProcessingMessage'
import { ProcessingSteps } from './ProcessingSteps/ProcessingSteps'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'
import { ReviseDesignProcessingContent } from 'api/clients/ChatClient'

const ESTIMATED_MINUTES: Record<string, number> = {
  generate_photo: 2,
  generate_video: 3,
}

export const ProcessingContent = ({ content, isNextGen }: ProcessingContentProps) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()

  const toolName = 'tool' in content ? content.tool : undefined
  const steps = 'steps' in content && content.steps?.length ? content.steps : undefined

  return (
    <>
      {steps ? (
        <ProcessingSteps
          steps={steps}
          estimatedMinutes={toolName ? ESTIMATED_MINUTES[toolName] : undefined}
          isNextGen={isNextGen}
        />
      ) : (
        <div className={Styles.loading}>
          <div className={Styles.loadingContent}>
            <Spinner variant={isSystemRedesignEnabled ? undefined : 'blue'} />
            <div className={Styles.loadingText}>
              <Text variant={isNextGen ? 'primary' : 'secondary'}>{content.text || 'Reading your message...'}</Text>
            </div>
          </div>
        </div>
      )}
      {toolName === 'revise_design' && <DesignProcessingMessage content={content as ReviseDesignProcessingContent} />}
    </>
  )
}
